module.exports = __webpack_public_path__ + "Roboto-Medium-webfont.b9d01ac1742192a7c9d3.woff";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Medium-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Medium-webfont.woff
// module chunks = 2